import type { PaletteMode } from "@mui/material";
import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";
import { type ReactNode, useState } from "react";
import { createAppTheme } from "@/theme/theme";
import { ThemeContext } from "./ThemeContext";

const STORAGE_KEY = "theme-mode";

const getInitialMode = (): PaletteMode => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "dark" || stored === "light") {
    return stored;
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [mode, setMode] = useState<PaletteMode>(getInitialMode);

  const toggleColorMode = () => {
    setMode((prev) => {
      const next = prev === "light" ? "dark" : "light";
      localStorage.setItem(STORAGE_KEY, next);
      return next;
    });
  };

  const theme = createAppTheme(mode);

  return (
    <ThemeContext value={{ toggleColorMode, mode }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext>
  );
};
